import { Inject, Injectable } from '@angular/core';
import { TranslatorService } from '@miq/utils';
import { L10N_LOCALE, L10nLocale, L10nTranslationService } from 'angular-l10n';

@Injectable()
export class MiqTranslationService extends TranslatorService {
  constructor(
    private translationService: L10nTranslationService,
    @Inject(L10N_LOCALE) public locale: L10nLocale
  ) {
    super();
  }

  translate(key: string, args: { [key: string]: any } = {}): string {
    return this.translationService.translate(key, args, this.locale.language);
  }

  has(key: string): boolean {
    return this.translationService.has(key, this.locale.language);
  }
}
